import { useRef, useEffect } from 'react'
import { useNavigate } from 'react-router-dom'
import { Table } from 'reactstrap'
import { enterKeyHandler } from '../../../utils'
import useForm from '../../CustomHooks/FormHook'
import '../Custom.css'
import { initialFormValues, submitFormValues } from '../CustomUtils'
import DateRangeInput from '../DateRangeInput'
import FormHeading from '../FormHeading'
import FormSubmitButton from '../FormSubmitButton'

export default function MonthlyCountForm({ location }) {
  console.log('MonthlyCountForm rendered: ', location)

  let init = {
    dateAssignedFrom: '',
    dateAssignedTo: '',
  }

  const navigate = useNavigate()
  init = initialFormValues('MonthlyCountForm', navigate, init)
  const { inputs, handleInputChange, handleSubmit } = useForm(init, submitSearch, enterKeyHandler(submitSearch))

  // Scroll error messages into view
  const scrollRef = useRef(null)
  useEffect(() => {
    if (scrollRef.current) {
      scrollRef.current.scrollIntoView()
    }
  }, [])

  async function submitSearch() {
    submitFormValues('MonthlyCountForm', navigate, inputs, 'monthly_count.report')
  }

  return (
    <div className="custom-scroll">
      <form className="form" onSubmit={handleSubmit} style={{ margin: '20px auto' }}>
        <div>
          <Table bordered className="custom-table custom-form-table" style={{ backgroundColor: 'white' }}>
            <FormHeading headingText={'Monthly Count Report'} />
            <tbody>
              <DateRangeInput label='Date Assigned' name='dateAssigned' handleInputChange={handleInputChange} defaultValueFrom={inputs.dateAssignedFrom} defaultValueTo={inputs.dateAssignedTo} />
            </tbody>
          </Table>
        </div>
        <FormSubmitButton label='Run Report' />
      </form>
    </div>
  )
}
